import { queryBot2 } from 'boot/axios';
import {
    calcDate,
    loadRoles,
    loadUserCourses,
    saveProjectItem,
} from 'src/model/projects';

export async function saveUser (userId, projectId, author = undefined) {
    let userDB;
    await queryBot2('saveUser', { userId }).then((r) => {
        const [result] = r.data;
        if (result && typeof result === 'object') {
            userDB = result;
        }
    });

    const roles = await loadRoles();
    const userCourses = await loadUserCourses(userId);
    if (!userCourses || typeof userCourses !== 'object' || !roles || typeof roles !== 'object') {
        return undefined;
    }

    const role = await roles.filter(i => i.course_id === userCourses.course_id).shift();
    const count = userDB && userDB.count ? parseInt(userDB.count, 10) + 1 : 1;
    const date = await calcDate();
    author = author && parseInt(author, 10) > 0 ? '1' : '0';

    let success;
    await queryBot2(userDB ? 'saveUserUpdate' : 'saveUserInsert', {
        projectId,
        role: role.name,
        date,
        count: userDB ? count : '0',
        author,
        userId,
    }).then((r) => {
        console.log('r', userDB ? 'saveUserUpdate' : 'saveUserInsert', r);
        success = {
            id: '0',
            user_id: userId,
            project_id: projectId,
            role: role.name,
            date,
            count: userDB ? count : '0',
            isAuthor: author,
        };
    });
    if (author) {
        await saveProjectItem({
            id: projectId,
            key: 'author',
            value: userId,
        });
    }
    return success;
}

export default saveUser;
